import React from 'react';
import Style from './BaseLayout.module.scss';
import Navbar from "./Navbar";
import { Box } from "@mui/material";
import MultiPageRoutes from './MultiPageRoutes';

export default function BaseLayout() {
   /*
      Note: `active` route tracking was previously duplicated here
      via useState + useLocation, but Navbar already derives its
      own `active` value internally from useLocation() and does
      not accept `active`/`setActive` as props. The local state
      here was therefore dead on arrival, and additionally went
      stale after the first client-side navigation because
      useState's initializer only runs once on mount.
      Removed in favor of Navbar's own source of truth.
   */

   return (
      <Box
         className={Style.appContainer}
         sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            width: '100%',
            overflowX: 'hidden'
         }}
      >
         <Box component="header">
            <Navbar />
         </Box>

         <Box
            component="main"
            sx={{
               flexGrow: 1,
               width: '100%',
               overflowX: 'hidden'
            }}
         >
            <MultiPageRoutes />
         </Box>

         <footer className={Style.footer}>
            <div className={Style.footerInner}>

               {/* Left: name + role */}
               <div className={Style.footerBrand}>
                  <span className={Style.brandName}>
                     Madhu Vanguri
                  </span>
                  <span className={Style.brandRole}>
                     Mechanical Design Engineer
                  </span>
               </div>

               {/* Centre: divider */}
               <div
                  className={Style.footerDivider}
                  aria-hidden="true"
               >
                  <span className={Style.dividerLine} />
                  <span className={Style.dividerDot} />
                  <span className={Style.dividerLine} />
               </div>

               {/* Right: credit + copyright */}
               <div className={Style.footerMeta}>
                  <span className={Style.metaText}>
                     Designed &amp; built by{' '}
                     <a
                        href="https://www.linkedin.com/in/madhuvanguri"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={Style.metaLink}
                     >
                        M. Vanguri
                     </a>
                  </span>

                  <span className={Style.metaText}>
                     © {new Date().getFullYear()} · Hyderabad, India
                  </span>
               </div>

            </div>
         </footer>
      </Box>
   );
}